import {makeAutoObservable} from 'mobx';
import moment from 'moment-timezone';

export enum Status {
	disabled,
	error,

	pending,
	running,
	expired,

	unknown,
}

export class Holder {
	private _id: string;
	private _status: Status = Status.unknown;
	private _expires: number = 0;
	private _error: string = '';
	private _created: string = '';

	constructor(id: string) {
		makeAutoObservable(this);
		this._id = id;
	}

	get id() {
		return this._id;
	}

	get status() {
		return this._status;
	}

	get active() {
		return this.status === Status.running ||
			this.status === Status.pending;
	}

	get expired() {
		return this.status === Status.expired;
	}

	get expires() {
		return this._expires;
	}

	get error() {
		return this._error;
	}

	get created() {
		return this._created;
	}

	calcRemaining() {
		if (this.expires <= 0 || !this.active) {
			return '00:00';
		}

		const seconds = this.expires - moment().unix();
		if (seconds <= 0) {
			return '00:00';
		}

		return moment.unix(seconds).format('mm:ss');
	}

	_setStatus(status: Status) {
		this._status = status;
	}

	setRemaining(remaining: number) {
		if (remaining > 0) {
			this._expires = moment().unix() + remaining;
			this._setStatus(Status.running);
		} else {
			this._setStatus(Status.expired);
		}
	}

	setError(message: string) {
		this._error = message;
		this._setStatus(Status.error);
	}

	setCreated(created: string) {
		this._created = created;
	}

	reset(runnable: boolean) {
		this._expires = 0;
		this._error = '';
		this._created = '';
		if (runnable) {
			this._setStatus(Status.pending);
		} else {
			this._setStatus(Status.disabled);
		}
	}
}
